import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

const getPublicList = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/public/forms/list',
    headers,
    successCallback,
    errorCallback,
  );
};

const getPublicForm = (formId, successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    `/api/public/forms/${formId}`,
    headers,
    successCallback,
    errorCallback,
  );
};

const submitPublicForm = (data, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/public/forms/submit',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );
};

const getList = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/forms/list',
    headers,
    successCallback,
    errorCallback,
  );
};

const getForm = (formId, successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    `/api/forms/${formId}`,
    headers,
    successCallback,
    errorCallback,
  );
};

const submitForm = (data, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/forms/submit',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );
};

const saveAsDraft = (data, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
    '/api/forms/save-draft',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );
};

const deleteDraft = (data, successCallback, errorCallback) => {
  return UpdoxApi.deleteApi(
    '/api/forms/draft',
    headers,
    JSON.stringify(data),
    successCallback,
    errorCallback,
  );
};

const FormsApi = {
  getPublicList,
  getPublicForm,
  submitPublicForm,
  getList,
  getForm,
  submitForm,
  saveAsDraft,
  deleteDraft,
};

export default FormsApi;



// WEBPACK FOOTER //
// ./src/apis/forms.js